export default __webpack_public_path__ + "static/media/vowels-norgx.1f024963.svg";